import degreeImg from "../../../../assets/images/mentor_profile/degree.png";
import universityImg from "../../../../assets/images/mentor_profile/university.png";
import phoneIcon from "../../../../assets/images/callIcon.png";
import emailIcon from "../../../../assets/images/mailIcon.png";
import highlightImg from "../../../../assets/images/mentor_profile/highlight.png";
import ReplayIcon from '@mui/icons-material/Replay';
import { useAboutMeStyles } from "./styles";

const isYouTubeLink = (url) =>
  url.includes("youtube.com") || url.includes("youtu.be");

const convertToEmbedUrl = (url) => {
  if (url.includes("youtu.be")) {
    const id = url.split("/").pop();
    return `https://www.youtube.com/embed/${id}`;
  }
  if (url.includes("watch?v=")) {
    const id = url.split("v=")[1].split("&")[0];
    return `https://www.youtube.com/embed/${id}`;
  }
  return url;
};

export const MentorProfileDetails = ({
  degree = "",
  college = "",
  isPublicProfile = false,
  contact_no = "",
  email = "",
  videoUrl = "",
  mockDemoVideoUrl = "",
  canEdit = false,
  onReplaceVideo,
  onReplaceDemoVideo,
}) => {
  const classes = useAboutMeStyles();

  return (
    <>
      {/* Academic background — always shown; fallback text on non-public */}
      {(degree || college || !isPublicProfile) && (
        <div className={classes.academicSection}>
          <div className={classes.academicSectionLabel}>My academic background:</div>
          <div className={classes.academicGrid}>
            {(degree || !isPublicProfile) && (
              <div className={classes.academicItem}>
                <img src={degreeImg} alt="degree" className={classes.academicIcon} />
                <span className={classes.academicText}>
                  {degree || "Degree not added"}
                </span>
              </div>
            )}
            {(degree || !isPublicProfile) && (college || !isPublicProfile) && (
              <div className={classes.verticalDivider} />
            )}
            {(college || !isPublicProfile) && (
              <div className={classes.academicItem}>
                <img src={universityImg} alt="university" className={classes.academicIcon} />
                <span className={classes.academicText}>
                  {college || "College not added"}
                </span>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Contact info — only on non-public profile */}
      {!isPublicProfile && (contact_no || email) && (
        <div className={classes.contactSection}>
          <div className={classes.academicSectionLabelContact}>My contact info:</div>
          <div className={classes.academicGrid}>
            {contact_no && (
              <div className={classes.academicItem}>
                <img src={phoneIcon} alt="phone" className={classes.academicIcon} />
                <span className={classes.academicText}>{contact_no}</span>
              </div>
            )}
            {contact_no && email && <div className={classes.verticalDivider} />}
            {email && (
              <div className={classes.academicItem}>
                <img src={emailIcon} alt="email" className={classes.academicIcon} />
                <span className={classes.academicText}>{email}</span>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Videos — only on non-public profile */}
      {!isPublicProfile && (videoUrl || mockDemoVideoUrl) && (
        <div className={classes.videosSection}>
          <div className={classes.videosSectionTitle}>
            Uploaded{" "}
            <span className={classes.titleME}>
              videos
              <img src={highlightImg} alt="" className={classes.videosHighlightImg} />
            </span>
          </div>
          <div className={classes.videosRow}>
          {videoUrl && (
            <div className={classes.videoCard}>
              <video className={classes.videoThumbnail} controls>
                <source src={videoUrl} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <div className={classes.videoLabelRow}>
                <span className={classes.videoLabel}>Intro video</span>
                {canEdit && (
                  <span className={classes.replaceBtn} onClick={onReplaceVideo}>
                    Replace <ReplayIcon style={{ fontSize: 16, verticalAlign: "middle" }} />
                  </span>
                )}
              </div>
            </div>
          )}
          {mockDemoVideoUrl && (
            <div className={classes.videoCard}>
              {isYouTubeLink(mockDemoVideoUrl) ? (
                <iframe
                  className={classes.videoThumbnail}
                  src={convertToEmbedUrl(mockDemoVideoUrl)}
                  title="Demo video"
                  frameBorder="0"
                  allowFullScreen
                />
              ) : (
                <video className={classes.videoThumbnail} controls>
                  <source src={mockDemoVideoUrl} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}
              <div className={classes.videoLabelRow}>
                <span className={classes.videoLabel}>Demo video</span>
                {canEdit && (
                  <span className={classes.replaceBtn} onClick={onReplaceDemoVideo}>
                    Replace <ReplayIcon style={{ fontSize: 16, verticalAlign: "middle" }} />
                  </span>
                )}
              </div>
            </div>
          )}
          </div>
        </div>
      )}
    </>
  );
};

